module.exports = __webpack_public_path__ + "img/home_icon.99e9fa3a.png";